import { postTiendaFrontUsoHit } from '@/services/tiendaFrontUsoApi';
import { getOrCreateKosexaFrontSessionId } from '@/utils/kosexaFrontSessionId';

let lastKey = '';
let timer = null;

/**
 * Telemetría mínima: un POST por cambio de ruta (debounce + dedupe en cliente y servidor).
 * La tienda la resuelve el API por `shp`; en operaciones el resumen separa por `origen=catalogo` (sin usuario OAuth).
 */
export function installFrontUsageTelemetry(router) {
  router.afterEach((to) => {
    const base = (
      (process.env.VUE_APP_API_URL_TIENDA || '').trim() ||
      (process.env.VUE_APP_API_URL || '').trim()
    );
    if (!base) return;

    const name = to.name != null ? String(to.name) : '';
    const path = to.path || '';
    const key = `${name}|${path}`;
    if (key === lastKey) return;

    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      lastKey = key;
      const routeLabel = name || 'sin-nombre';
      postTiendaFrontUsoHit({
        route_name: routeLabel,
        path: path.slice(0, 280),
        session_id: getOrCreateKosexaFrontSessionId(),
      }).catch(() => {});
    }, 400);
  });
}
